import { LABEL_FONT_SIZE } from '../x-axis/constants';

const labelCharWidth = (fontSize: number) => fontSize * 0.47;

const maxCharsForWidth = (maxWidthPx: number, fontSize: number) =>
  Math.max(1, Math.floor(maxWidthPx / labelCharWidth(fontSize)));

const splitFundAssetValueLabel = (label: string, maxLines: number) => {
  const match = /^Fund asset value (.+)$/.exec(label);

  if (!match) {
    return null;
  }

  return ['Fund asset value', match[1]].slice(0, maxLines);
};

const wrapSvgLabel = (
  label: string,
  maxWidthPx: number,
  maxLines: number,
  fontSize: number = LABEL_FONT_SIZE,
) => {
  const fundAssetLines = splitFundAssetValueLabel(label, maxLines);

  if (fundAssetLines) {
    return fundAssetLines;
  }

  const maxChars = maxCharsForWidth(maxWidthPx, fontSize);
  const words = label.split(/\s+/).filter(Boolean);

  if (words.length === 0) {
    return [];
  }

  if (maxLines <= 1) {
    return [label.slice(0, maxChars)];
  }

  const lines: Array<string> = [];
  let currentLine = '';

  for (let i = 0; i < words.length; i += 1) {
    const candidate = currentLine ? `${currentLine} ${words[i]}` : words[i];

    if (candidate.length <= maxChars) {
      currentLine = candidate;
      continue;
    }

    if (currentLine) {
      lines.push(currentLine);
    }

    if (lines.length === maxLines - 1) {
      lines.push(words.slice(i).join(' ').slice(0, maxChars));
      return lines;
    }

    currentLine = words[i];
  }

  if (currentLine) {
    lines.push(currentLine);
  }

  return lines.slice(0, maxLines);
};

export default wrapSvgLabel;
